export var COMMIT_TYPE = {
    Initializing: 'setInitializing',
    InitializationData: 'setInitializationData',
    IsLoadingMachineInformation: 'setIsLoadingMachineInformation',
    MachineInformation: 'setMachineInformation',
    ValidationCollector: 'setValidationCollector',
    IsCreating: 'setIsCreating',
    IsAdding: 'setIsAdding',
    PartialSubmit: 'setPartialSubmit',
    Registration: 'setRegistration',
    MachineRegistrationData: 'setMachineRegistrationData',
    Attachment: 'setAttachment',
    SetErrors: 'setErrors',
    ResetErrors: 'resetErrors',
    Files: 'setFiles',
};
